import type { ElementType, HTMLAttributes } from 'react'
import { cls } from './cls'

const PADDING = { sm: 'p-3', md: 'p-5' }

type CardTag = 'div' | 'section' | 'article' | 'aside' | 'li'

export interface CardProps extends HTMLAttributes<HTMLElement> {
  as?: CardTag
  padding?: keyof typeof PADDING
  /** Softly rounded rather than the house square corner. */
  rounded?: boolean
  /** Sits on the page background instead of white. */
  transparent?: boolean
}

/** A bordered surface. */
export function Card({
  as = 'div',
  padding = 'md',
  rounded = false,
  transparent = false,
  className,
  ...rest
}: CardProps) {
  const Tag = as as ElementType
  return (
    <Tag
      className={cls(
        'border border-border',
        transparent ? '' : 'bg-white',
        rounded && 'rounded',
        PADDING[padding],
        className,
      )}
      {...rest}
    />
  )
}
